import SurveyPage from "@/app/(app)/(crew)/supervising/[shift]/survey";

export default SurveyPage;
